import type { MobileSegmentedTab } from '@/features/mobile-ui';
import { Film, Paintbrush } from 'lucide-react';

/** Two groups: videos (generated + uploaded) and graphics (rendered + images). */
export type AdMobileMediaTab = 'videos' | 'graphics';

export const AD_MOBILE_MEDIA_FILTER_TABS: MobileSegmentedTab[] = [
  {
    value: 'videos',
    label: 'Videos',
    icon: Film,
    ariaLabel: 'Videos',
  },
  {
    value: 'graphics',
    label: 'Graphics',
    icon: Paintbrush,
    ariaLabel: 'Graphics',
  },
];
